/**
 * Apple Pay browser-bridge policy shared by hosted, embedded, and Elements
 * surfaces. Centralizing these values prevents the three entry points from
 * silently negotiating different session versions or timeout behavior.
 */
export const APPLE_PAY_BRIDGE_POLICY = {
  preferredSessionVersion: 14,
  compatibilitySessionVersion: 3,
  merchantValidationTimeoutMs: 15_000,
  modalUpgradeAnimationFrames: 10,
} as const;

export function selectApplePaySessionVersion(ApplePayAPI: any): number {
  return ApplePayAPI.supportsVersion?.(APPLE_PAY_BRIDGE_POLICY.preferredSessionVersion)
    ? APPLE_PAY_BRIDGE_POLICY.preferredSessionVersion
    : APPLE_PAY_BRIDGE_POLICY.compatibilitySessionVersion;
}
